import {
  TUseCommentGeneralUtils,
  TUseCommentHook,
  TUseMetaRole,
  TUsePinnedCommentHook,
  TUseReplyCommentHook,
} from '../../../interfaces/hook.interface';
import useComment from './useComment';
import { useMetaRole } from './useMetaRole';
import usePinnedComment from './usePinnedComment';
import { useReplyComment } from './useReplyComment';

const usePostCommentGeneralUtils: TUseCommentGeneralUtils = (
  _commentSectionId,
  cb
) => {
  return {
    useCommentHook: (() =>
      useComment(_commentSectionId, cb)) as TUseCommentHook,
    useReplyCommentHook: ((_commentId) =>
      useReplyComment(_commentId, _commentSectionId)) as TUseReplyCommentHook,
    useMetaRoleHook: useMetaRole as TUseMetaRole,
    usePinnedCommentHook: (() =>
      usePinnedComment(_commentSectionId)) as TUsePinnedCommentHook,
  };
};

export default usePostCommentGeneralUtils;
